export default {
	namespaced: true,

	state: {
		showEditDialog: false,
		showImportDialog: false,

		editKey: null,
		editItem: {},

		input: {},
		data: {},
		result: [],
		error: [],
		// for user
		users: {},
		// for group
		groups: {},
		// for point
		criteria: {
			// code: {
			//		name: null,
			//		description: null
			// }
		},
		vouchers: {},
		// for training
		trainings: {}
	},

	getters: {
		get: state => state
	},

	mutations: {
		setValue (state, [key, value]) {
			state[key] = value;
		},
		setSubValue (state, [key, subKey, value]) {
			state[key][subKey] = value;
		}
	},

	actions: {
	}
}
